export default value => parseInt(value) === value
